import ufeApi from 'services/api/ufeApi';
import apiUtils from 'utils/Api';
import urlUtils from 'utils/Url';
import userUtils from 'utils/User';
import javascriptUtils from 'utils/javascript';
const { buildQuery } = urlUtils;
const { buildMap } = javascriptUtils;

const { addBrowseExperienceParams } = apiUtils;

// https://jira.sephora.com/wiki/display/ILLUMINATE/Type+Ahead+Search+API

function searchTypeAhead(query, includeOnlyProducts = false, suggestions = {}, refinements) {
    const constructorSessionID = !!global.ConstructorioTracker && global.ConstructorioTracker.getSessionID();
    const constructorClientID = !!global.ConstructorioTracker && global.ConstructorioTracker.getClientID();
    const isNLPSearchEnabled = Sephora.configurationSettings.isNLPSearchEnabled;
    const isNLPInstrumentationEnabled = Sephora.configurationSettings.isNLPInstrumentationEnabled;
    const includeConstructorParams = isNLPSearchEnabled && constructorSessionID && constructorClientID;
    const { productSuggestions = 6, searchSuggestions = 3, categorySuggestions = 5 } = suggestions;
    let url = '/api/v2/catalog/search/';

    const type = 'typeAhead';
    const targetSearchEngine = 'nlp';

    const queryParams = buildQuery(
        buildMap({
            type,
            q: encodeURIComponent(query),
            ...(includeOnlyProducts && { includeOnlyProducts }),
            searchSuggestions,
            productSuggestions,
            categorySuggestions,
            ...(isNLPInstrumentationEnabled
                ? includeConstructorParams && { constructorSessionID, constructorClientID, targetSearchEngine }
                : { targetSearchEngine }),
            ...(refinements && { ref: refinements })
        })
    );

    url = url + queryParams;

    const opts = {
        'user-segment': 'external-app'
    };
    const config = {
        service: 'search',
        isSXSSearchEnabled: true
    };

    const profileId = userUtils.getProfileId();

    if (profileId) {
        opts.atgID = profileId;
    }

    addBrowseExperienceParams(opts, config);

    if (Object.keys(opts).length) {
        url += '&' + urlUtils.makeQueryString(opts);
    }

    return ufeApi.makeRequest(url, { method: 'GET' }).then(data => (data.errorCode ? Promise.reject(data) : data));
}

export default searchTypeAhead;
